import { Img } from 'openimg/react'
import { useRef } from 'react'
import { Link, Form } from 'react-router'
import { getUserImgSrc } from '#app/utils/misc.tsx'
import { useUser } from '#app/utils/user.ts'
import { Button } from './ui/button'
import {
	DropdownMenu,
	DropdownMenuTrigger,
	DropdownMenuPortal,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
} from './ui/dropdown-menu'
import { Icon } from './ui/icon'

/**
 * The avatar button in the site header (marketing, auth, settings pages):
 * a menu with the app, its settings, the account profile and logout. The
 * link itself goes to /app/instellingen — the same place the app shell's
 * avatar goes (ADR-027 §4) — so it works before hydration too.
 */
export function UserDropdown() {
	const user = useUser()
	const formRef = useRef<HTMLFormElement>(null)
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button asChild variant="secondary" size="icon" className="p-0">
					<Link
						to="/app/instellingen"
						// this is for progressive enhancement
						onClick={(e) => e.preventDefault()}
						className="flex items-center"
						aria-label="Gebruikersmenu"
					>
						<Img
							className="size-9 rounded-full object-cover"
							alt={user.name ?? user.username}
							src={getUserImgSrc(user.image?.objectKey)}
							width={256}
							height={256}
							aria-hidden="true"
						/>
					</Link>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuPortal>
				<DropdownMenuContent sideOffset={8} align="end">
					<DropdownMenuLabel className="text-muted-foreground text-[15px] font-bold">
						{user.name ?? user.username}
					</DropdownMenuLabel>
					<DropdownMenuItem asChild>
						<Link prefetch="intent" to="/app">
							<Icon className="text-body-md" name="house">
								Oyka-app
							</Icon>
						</Link>
					</DropdownMenuItem>
					<DropdownMenuItem asChild>
						<Link prefetch="intent" to="/app/instellingen">
							<Icon className="text-body-md" name="plugs">
								Instellingen
							</Icon>
						</Link>
					</DropdownMenuItem>
					<DropdownMenuItem asChild>
						<Link prefetch="intent" to="/settings/profile">
							<Icon className="text-body-md" name="avatar">
								Profiel
							</Icon>
						</Link>
					</DropdownMenuItem>
					<DropdownMenuSeparator />
					<Form action="/logout" method="POST" ref={formRef}>
						<DropdownMenuItem asChild>
							<button type="submit" className="w-full">
								<Icon className="text-body-md" name="exit">
									Uitloggen
								</Icon>
							</button>
						</DropdownMenuItem>
					</Form>
				</DropdownMenuContent>
			</DropdownMenuPortal>
		</DropdownMenu>
	)
}
